import * as yup from 'yup';
import { assetFormFields } from '../../fields/formFields';

export const assetFormSchema = yup.object({
  [assetFormFields.nameEn]: yup.string().required('Asset Name En is required').trim(),
  [assetFormFields.nameAr]: yup.string().required('Asset Name Ar is required').trim(),
  [assetFormFields.descriptionEn]: yup.string().required('Asset Description En is required').trim(),
  [assetFormFields.descriptionAr]: yup.string().required('Asset Description Ar is required').trim(),
});
